import { Stack } from '@mui/material';
import { FC, ReactNode } from 'react';

import { Badge, theme, Typography } from '@/shared/design-system';

import { FieldIconBox, FieldLabelColumn, FieldValueText } from './styled';

export interface FieldRowValue {
  value: string;
  badge?: string;
  /** Renders the value as plain text with a trailing green "added" badge (auto-merge's "after merge" column). */
  added?: boolean;
}

interface FieldRowProps {
  icon: ReactNode;
  label: string;
  values: FieldRowValue[];
}

export const FieldRow: FC<FieldRowProps> = ({ icon, label, values }) => {
  if (values.length === 0) return null;

  return (
    <Stack alignItems="flex-start" gap="8px">
      <FieldIconBox>{icon}</FieldIconBox>
      <FieldLabelColumn>
        <Typography variant="body3" fontWeight={500} color={theme.colors.text.secondary}>
          {label}
        </Typography>
        <Stack flexDirection="column" gap="6px">
          {values.map((item, index) => (
            <Stack key={`${item.value}-${index}`} alignItems="center" gap="6px">
              {item.added ? (
                <>
                  <FieldValueText variant="body3" color={theme.colors.text.primary}>
                    {item.value}
                  </FieldValueText>
                  <Badge label="added" size="sm" color="primary" variant="subtle" />
                </>
              ) : (
                <>
                  <FieldValueText variant="body3" color={theme.colors.text.primary}>
                    {item.value}
                  </FieldValueText>
                  {item.badge && <Badge label={item.badge} size="sm" />}
                </>
              )}
            </Stack>
          ))}
        </Stack>
      </FieldLabelColumn>
    </Stack>
  );
};
